import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  root: {
    display: 'block',
    maxWidth: '100%',
  },
}));
